/**
 * Canonical SVR billing amount authority: nearest cent only.
 * Do not round SVR invoice amounts to whole dollars.
 */
import { moneyToFixed2, roundSgd2 } from "./portalInvoiceLineItems";

export function normalizeSvrBillingAmount(raw: unknown): number {
  const n = typeof raw === "number" ? raw : Number(String(raw ?? "").trim());
  if (!Number.isFinite(n)) {
    throw new Error("SVR billing amount is invalid");
  }
  return roundSgd2(n);
}

export function svrBillingAmountToDecimalString(raw: unknown): string {
  return moneyToFixed2(normalizeSvrBillingAmount(raw));
}

export function formatSvrBillingAmountDisplay(raw: unknown): string {
  return svrBillingAmountToDecimalString(raw);
}

export function formatSvrBillingMoneyDollar(raw: unknown): string {
  return `$${formatSvrBillingAmountDisplay(raw)}`;
}

export function formatSvrBillingMoneySgd(raw: unknown): string {
  return `SGD ${formatSvrBillingAmountDisplay(raw)}`;
}

export function tryNormalizeSvrBillingAmount(raw: unknown): number | null {
  try {
    const n = normalizeSvrBillingAmount(raw);
    return n > 0 ? n : null;
  } catch {
    return null;
  }
}
